import type { RouteObject } from "react-router-dom";

/*
  The Shared parts view of the 2026-11-03 design (rebuild stage 4.3, frontend part). The view loads when it is first opened.
  Who may open the address is in `app/screens.ts`; it is not repeated here.
*/

export const routes: RouteObject[] = [{ path: "/shared", lazy: async () => ({ Component: (await import("./SharedView")).SharedView }) }];
